import React from "react";

const Benefits = () => {
  return (
    <section id="benefits" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4" id="el-cias9ft1">
        {/* Section Header */}
        <div className="text-center mb-16" id="el-ecvdhkch" data-aos="fade-up">
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
            id="el-328frlcc"
          >
            Benefits
          </h2>
          <p
            className="text-lg text-gray-600 max-w-3xl mx-auto"
            id="el-vsj5ibhr"
          >
            Discover why thousands of rural entrepreneurs and farmers choose
            GeeCom's digital solutions.
          </p>
        </div>

        {/* Benefits Featured */}
        <div
          className="bg-white rounded-2xl shadow-sm overflow-hidden mb-16 animate-slide-in"
          id="el-lxwp45tq"
          data-aos="fade-up"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2" id="el-1ia7u7sb">
            {/* Image Column */}
            <div className="relative" id="el-uajo4ts5" data-aos="zoom-in">
              <img
                src="https://images.unsplash.com/photo-1559807232-7adaa1c756b7?..."
                alt="Person receiving digital support and guidance"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://placehold.co/800x600?text=Digital+Support";
                  e.target.classList.add("object-contain", "p-4");
                }}
                className="w-full h-full object-cover"
                width="5986"
                height="3991"
                id="el-zvf5j7up"
              />
              <div
                className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 p-4 text-white text-xs"
                id="el-yoejlnvd"
              >
                Photo by Dan Burton (@dan__burton)
              </div>
            </div>

            {/* Content Column */}
            <div
              className="p-8 md:p-12 flex flex-col justify-center"
              id="el-dcrn7xp3"
              data-aos="fade-left"
            >
              <h3
                className="text-2xl font-bold text-gray-900 mb-6"
                id="el-vqxdb0zc"
              >
                Transform Your Business Digitally
              </h3>
              <div className="space-y-6" id="el-4nmm5f03">
                {/* Benefit 1 */}
                <div
                  className="flex items-start"
                  id="el-0wrunt5i"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div
                    className="flex-shrink-0 h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center mr-4"
                    id="el-4qyzpwvl"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-blue-600"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-medium text-gray-900 mb-1">
                      Reach Thousands of People
                    </h4>
                    <p className="text-gray-600">
                      Increase visibility and sales via digital mediums without
                      any technical expertise.
                    </p>
                  </div>
                </div>

                {/* Benefit 2 */}
                <div
                  className="flex items-start"
                  id="el-sen0p7zt"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="flex-shrink-0 h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-blue-600"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-medium text-gray-900 mb-1">
                      Save Hours of Work
                    </h4>
                    <p className="text-gray-600">
                      Convert paperwork into digital records in minutes instead
                      of days or weeks.
                    </p>
                  </div>
                </div>

                {/* Benefit 3 */}
                <div
                  className="flex items-start"
                  id="el-1k1j8vrs"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="flex-shrink-0 h-12 w-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 text-blue-600"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-lg font-medium text-gray-900 mb-1">
                      Viral Sharing Effect
                    </h4>
                    <p className="text-gray-600">
                      Admirers of your products will share your QR code,
                      expanding your reach organically.
                    </p>
                  </div>
                </div>
              </div>

              <a
                href="#contact"
                className="mt-8 inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-6 rounded-md transition-colors duration-300"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                Start Benefiting Today
                {/* Arrow Icon */}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
